export default "__VITE_ASSET__DceMvO$x__"